import {interopDefault} from '@/utils/helpers'
import {srcHost} from '~src/utils/host-adapter'
import {axiosInstance} from '~/utils/axios-accessor'
import {appInstance} from '@/utils/app-accessor'

const HotelsPage = () => interopDefault(import('~src/pages/hotels/hotelsPage.src'))
const HotelPage = () => interopDefault(import('~src/pages/hotels/hotelPage.src'))
const ComparisonPage = () => interopDefault(import('@/pages/comparison/ComparisonPage'))
const HotelBookingConfirmationPage = () => interopDefault(import('@/pages/booking/HotelBookingConfirmationPage'))
const HotelBookingPage = () => interopDefault(import('~src/pages/hotels/hotelBookingPage.src'))
const SearchFormPage = () => interopDefault(import('@/pages/hotels/SearchFormPage'))

export default [
    {
        path: '/search/hotels',
        component: HotelsPage,
        name: 'hotels',
        meta: {
            unwrapped: true,
            validate: route => {
                if (appInstance.$conf.public.searchWithoutDestination) {
                    return true
                }

                return !!route.query.cityId
            },
        },
    },
    {
        path: '/hotel/:name',
        component: HotelPage,
        name: 'hotel',
        meta: {
            unwrapped: true,
            validate: async route => {
                const {supplierCode, cityCode, hotelCode, cityId, hotelId} = route.query
                if (appInstance.$conf.public.searchWithoutDestination) {
                    if (hotelId || (supplierCode && cityCode && hotelCode)) return true
                }

                if (cityId && (hotelId || (supplierCode && cityCode && hotelCode))) return true
                const hotel = await axiosInstance.$get(srcHost(`/proxy/hotel/${route.params.name}`))
                return !!hotel
            },
        },
    },
    {
        path: '/hotel-info/:name',
        component: HotelPage,
        name: 'hotelInfo',
        meta: {
            unwrapped: true,
            validate: async route => {
                const {supplierCode, cityCode, hotelCode, cityId, hotelId} = route.query
                if (appInstance.$conf.public.searchWithoutDestination) {
                    if (hotelId || (supplierCode && cityCode && hotelCode)) return true
                }

                if (cityId && (hotelId || (supplierCode && cityCode && hotelCode))) return true
                const hotel = await axiosInstance.$get(srcHost(`/proxy/hotel/${route.params.name}`))
                return !!hotel
            },
        },
    },

    // TODO [P4] Check purpose
    {
        path: '/hotel',
        component: HotelPage,
        name: 'hotelLink',
        meta: {
            unwrapped: true,
            validate: async route => {
                const {supplierCode, cityCode, hotelCode, cityId, hotelId} = route.query
                if (appInstance.$conf.public.searchWithoutDestination) {
                    if (hotelId || (supplierCode && cityCode && hotelCode)) return true
                }

                if (cityId && (hotelId || (supplierCode && cityCode && hotelCode))) return true
                const hotel = await axiosInstance.$get(srcHost(`/proxy/hotel/${route.params.name}`))
                return !!hotel
            },
        },
    },

    {
        path: '/hotels/compare',
        component: ComparisonPage,
        name: 'comparison',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/hotels/confirmation',
        component: HotelBookingConfirmationPage,
        name: 'hotelsConfirmation',
        meta: {
            unwrapped: true,
            validate: route => !!route.query.orderId,
        },
    },
    {
        path: '/hotels/booking',
        component: HotelBookingPage,
        name: 'hotelBooking',
        meta: {
            unwrapped: true,
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/hotels/search-form',
        component: SearchFormPage,
        name: 'searchForm',
        meta: {
            layout: 'pure',
        },
    },
]
